import React from 'react';
import { AppBar, Box, Link, Toolbar, Typography } from '@mui/material';

const NEW_HOME = 'https://vorakit.com/texteditor';

const inter = '"Inter", sans-serif';

const Header = () => {
  return (
    <AppBar 
      position="static" 
      sx={{ 
        backgroundColor: '#21456d', // Dark blue, similar to TabBar
        color: 'white', // White text for contrast
        borderTopLeftRadius: 10, // Rounded top-left corner
        borderTopRightRadius: 10, // Rounded top-right corner
        boxShadow: 'none', // Optional: remove shadow for a flatter design
      }}
    >
      <Toolbar variant="dense" sx={{ minHeight: 56, py: 0.75 }}>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: inter,
              fontWeight: 600,
              fontSize: 20,
              lineHeight: 1.2,
              letterSpacing: '-0.01em',
              color: '#FFFFFF',
            }}
          >
            WebPad++ has moved
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontFamily: inter,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 1.4,
              mt: '5px',
              color: '#E2E8F0',
            }}
          >
            Now available at{' '}
            <Link
              href={NEW_HOME}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                fontFamily: inter,
                fontWeight: 500,
                fontSize: 'inherit',
                color: '#A5B4FC',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              vorakit.com/texteditor
            </Link>
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontFamily: inter,
              fontSize: 12,
              mt: '4px',
              color: '#FBBF24',
            }}
          >
            This site will be discontinued on April 30
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
